function Footer() {
    return <footer className="grid-footer bg-primary navbar-dark fs-6 text-center p-2">
        <span className="navbar-text display-7">The Trading Playground -- Wyckoff Position Index</span>
    </footer>
}

export default Footer;